/**
 * Flags de fase do módulo.
 *
 * `VALIDACAO_USABILIDADE` é o interruptor da fase atual: cada passo abre um
 * modal-esboço com o nome da etapa em vez de disparar a ação real. Mantemos o
 * registry (`utils/journey-step-actions`) intacto por baixo — virar esta
 * constante para `false` devolve o comportamento definitivo sem tocar em
 * componente nenhum.
 */
export const VALIDACAO_USABILIDADE = true
